'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FocalPoint = require('./focal-point');
var React = require('react');

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusTrap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call.apply(_ref, [this].concat(args))), _this), _this._onKeyUp = function (event) {
      if (event.key === 'Escape' && 'onExit' in _this.props) {
        _this.props.onExit();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusTrap, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          children = _props.children,
          element = _props.element,
          onExit = _props.onExit;


      if (!active) return null;

      return React.createElement(
        'div',
        { className: className + '-wrapper', onKeyUp: this._onKeyUp },
        React.createElement('div', {
          'aria-hidden': 'true',
          className: className + '-backdrop',
          onClick: onExit
        }),
        React.createElement(
          FocalPoint,
          { ref: 'focus', className: className, element: element },
          children
        )
      );
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  className: 'focus-trap'
};


module.exports = FocusTrap;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/react-focus-trap/src/focus-trap.js
// module id = 1025
// module chunks = 0 1 2 3 4 5 6 7 8 9 10